import api from '@/api/api'
import router from '@/router/index'
import { schema } from 'normalizr'

export const comprador = new schema.Entity('comprador')

export default {
  namespaced: true,
  state: {
    list: {}
  },
  actions: {
    load ({ dispatch }, id) { // Devuelve todas las facturas
      return new Promise((resolve, reject) => {
        api.get('/pagos/get', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                id
              }
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    pagarStripe ({ dispatch }, {id, cardName, cardNumber, cardExpMonth, cardExpYear, cardCvc}) {
      return new Promise((resolve, reject) => {
        api.post('/pagos/pagar_stripe', {
          jsondata: JSON.stringify({
            parametros: {
              id,
              cardName,
              cardNumber,
              cardExpMonth,
              cardExpYear,
              cardCvc
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.url)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarPagoStripe ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.get('/pagos/comprobar_pago_stripe', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                id
              }
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    pagarTransferencia ({ dispatch }, {id, justificante}) {
      return new Promise((resolve, reject) => {
        api.post('/pagos/pagar_transferencia', {
          jsondata: JSON.stringify({
            parametros: {
              id,
              justificante
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    pagarGratis ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/pagos/pagar_gratis', {
          jsondata: JSON.stringify({
            parametros: {
              id
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    validarPago ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/pagos/validar_pago', {
          jsondata: JSON.stringify({
            parametros: {
              id: obj.id,
              validacion: obj.validacion
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/pagos/store.js